import React, { useState, useEffect } from 'react';
import { locationUtils } from '../../utils/locationUtils';

const CountryCurrencyTest = () => {
    const [testResults, setTestResults] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const runTests = async () => {
        setIsLoading(true);
        const results = {};

        try {
            // Test 1: Location Detection
            console.log('Testing location detection...');
            const locationData = await locationUtils.detectUserCountry();
            results.locationDetection = {
                success: true,
                data: locationData
            };

            // Test 2: Gateway Mapping for different countries
            console.log('Testing gateway mapping...');
            const testCountries = ['IN', 'US', 'CA', 'GB', 'AU', 'EU', 'JP', 'CN', 'BR', 'MX'];
            const gatewayResults = {};

            testCountries.forEach(countryCode => {
                const gatewayData = locationUtils.getCountryAndCurrencyForGateway(countryCode);
                gatewayResults[countryCode] = gatewayData;
            });

            results.gatewayMapping = {
                success: true,
                data: gatewayResults
            };

            // Test 3: Registration Data Structure
            console.log('Testing registration data structure...');
            const mockFormData = {
                client_name: 'Test Company',
                contact_name: 'John Doe',
                contact_email: 'john@test.com',
                contact_phone: '+1234567890'
            };

            const registrationData = {
                ...mockFormData,
                country_code: locationData.countryCode,
                currency_code: locationData.currency,
                plan_data: {
                    plan_id: 1,
                    plan_name: 'Free',
                    base_price: 0,
                    user_limit: 1,
                    ai_tokens_limit: 1000,
                    billing_cycle: 'Monthly'
                }
            };

            results.registrationData = {
                success: true,
                data: registrationData
            };

        } catch (error) {
            console.error('Test error:', error);
            results.error = error.message;
        }

        setTestResults(results);
        setIsLoading(false);
    };

    useEffect(() => {
        runTests();
    }, []);

    return (
        <div style={{ padding: '20px', fontFamily: 'monospace', maxWidth: '1200px' }}>
            <h2>Country & Currency Detection Test</h2>
            
            <div style={{ marginBottom: '20px' }}>
                <button 
                    onClick={runTests} 
                    disabled={isLoading}
                    style={{ padding: '10px 20px', marginRight: '10px' }}
                >
                    {isLoading ? 'Running Tests...' : 'Run Tests Again'}
                </button>
            </div>

            {/* Test Results */}
            {Object.keys(testResults).length > 0 && (
                <div>
                    {/* Location Detection */}
                    {testResults.locationDetection && (
                        <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
                            <h3>📍 Location Detection:</h3>
                            <pre style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '3px', overflow: 'auto' }}>
                                {JSON.stringify(testResults.locationDetection.data, null, 2)}
                            </pre>
                        </div>
                    )}

                    {/* Gateway Mapping */}
                    {testResults.gatewayMapping && (
                        <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
                            <h3>💳 Payment Gateway Mapping:</h3>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '10px' }}>
                                {Object.entries(testResults.gatewayMapping.data).map(([country, data]) => (
                                    <div key={country} style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '3px', border: '1px solid #ddd' }}>
                                        <strong>{country}:</strong>
                                        <br />
                                        Country Code: {data.country_code}
                                        <br />
                                        Currency: {data.currency_code}
                                        <br />
                                        Gateway: {data.gateway}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Registration Data */}
                    {testResults.registrationData && (
                        <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
                            <h3>📝 Registration Data Structure:</h3>
                            <pre style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '3px', overflow: 'auto' }}>
                                {JSON.stringify(testResults.registrationData.data, null, 2)}
                            </pre>
                        </div>
                    )}

                    {/* Error */}
                    {testResults.error && (
                        <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f8d7da', borderRadius: '5px', color: '#721c24' }}>
                            <h3>❌ Error:</h3>
                            <p>{testResults.error}</p>
                        </div>
                    )}
                </div>
            )}

            {/* Summary */}
            <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#d1ecf1', borderRadius: '5px' }}>
                <h3>📋 Summary:</h3>
                <p><strong>Country Detection:</strong> {testResults.locationDetection ? '✅ Working' : '❌ Failed'}</p>
                <p><strong>Gateway Mapping:</strong> {testResults.gatewayMapping ? '✅ Working' : '❌ Failed'}</p>
                <p><strong>Registration Data:</strong> {testResults.registrationData ? '✅ Working' : '❌ Failed'}</p>
                <p><strong>Overall Status:</strong> {testResults.error ? '❌ Has Errors' : '✅ All Tests Passed'}</p>
            </div>
        </div>
    );
};

export default CountryCurrencyTest; 